import * as React from 'react';
import { Icon, IconProps } from '../Icon';

export const CaretDown: React.FC<IconProps> = (props) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <polygon points="0 5 7.99946869 12.2709884 16 5"></polygon>
  </Icon>
);
